import React, { Component } from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import HtmlContent from "../components/HtmlContent"
import Layout from "../components/Layout"
import Img from "gatsby-image"
import PortfolioLightbox from "../components/Lightbox"

class PortfolioPageTemplate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      photoIndex: 0,
      isOpen: false,
    }

    this.clickThumbnail = this.clickThumbnail.bind(this)
    this.onLightboxCloseRequest = this.onLightboxCloseRequest.bind(this)
    this.onIndexChanged = this.onIndexChanged.bind(this)
    this.renderProjects = this.renderProjects.bind(this)
  }

  clickThumbnail = e => {
    const index = e.currentTarget.getAttribute("data-index")
    this.setState({
      photoIndex: parseInt(index),
      isOpen: true,
    })
  }

  onLightboxCloseRequest = () => {
    this.setState({ isOpen: false })
  }

  onIndexChanged = index => {
    this.setState({ photoIndex: index })
  }

  renderProjects = projects => {
    let counter = -1
    return projects.map((p, index) => (
      <section key={index}>
        <h3>{p.name}</h3>
        <div className="box alt">
          <div className="row gtr-uniform gtr-50">
            {p.images.map((image, i) => {
              counter++
              return (
                <div
                  key={counter}
                  data-index={counter}
                  class="col-4"
                  onClick={this.clickThumbnail}
                >
                  <span class="image fit">
                    <Img
                      data-index={counter}
                      fluid={image.image.childImageSharp.thumbs}
                      alt={image.alt}
                      title={image.alt}
                    />
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </section>
    ))
  }

  render() {
    const { title, overview, content, subtext, projects } = this.props
    const popUpImages = projects
      .map(p =>
        p.images.map(im => im.image.childImageSharp.popup).map(cis => cis.src)
      )
      .flat()

    return (
      <section id="main" class="wrapper">
        <div class="inner">
          <header class="major">
            <h2>{title}</h2>
            <p>{overview}</p>
            <p>{subtext}</p>
          </header>
          <HtmlContent content={content} className="content" />
          {this.renderProjects(projects)}
        </div>
        <PortfolioLightbox
          images={popUpImages.map(p => p)}
          photoIndex={this.state.photoIndex}
          isOpen={this.state.isOpen}
          onLightboxCloseRequest={this.onLightboxCloseRequest}
          onIndexChanged={this.onIndexChanged}
        />
      </section>
    )
  }
}

PortfolioPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  overview: PropTypes.string,
  subtext: PropTypes.string,
  projects: PropTypes.arrayOf(PropTypes.object),
}

const PortfolioPage = ({ data }) => {
  const { markdownRemark: post } = data
  return (
    <Layout isHome={false}>
      <PortfolioPageTemplate
        title={post.frontmatter.title}
        content={post.html}
        overview={post.frontmatter.overview}
        subtext={post.frontmatter.subtext}
        projects={post.frontmatter.projects}
      />
    </Layout>
  )
}

export default PortfolioPage

PortfolioPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export const pageQuery = graphql`
  query PortfolioPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        overview
        subtext
        projects {
          name
          images {
            alt
            image {
              childImageSharp {
                thumbs: fluid(maxWidth: 362, maxHeight: 182, quality: 70) {
                  ...GatsbyImageSharpFluid
                }
                popup: fluid(maxHeight: 700, quality: 90) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
